import mathsMap from './maths-map.md'

const data = {
    unique: "maths-map",
    title: "Non-linear dimensionality reduction",
    subhead: "Exploring social and professional boundaries with machine learning",
    image: "/images/2020/maths-map/maths-map-thumb.png",
    imageThumb: "/images/2020/maths-map/maths-map-thumb.png",
    imageLabel: "Maths map article",
    link: "/news/maths-map",
    file: mathsMap
}

export default data;